import React, { Suspense } from 'react';
import CircularProgress from '../../../components/CircularProgress';

const AccountInvitesList = React.lazy(() => import('../components/AccountInvitesList'));
function AccountInvitesListView(props: any) {
  return (
    <Suspense fallback={<CircularProgress />}>
      <AccountInvitesList {...props} />
    </Suspense>
  );
}

export default AccountInvitesListView;
